<template>
  <div
    class="kd-grafik-url__text"
      :class="{
        'kd-grafik-url__text--rotated': isVertical,
        'kd-grafik-url__text--right': orientation === directions.RIGHT,
        'kd-grafik-url__text--left': orientation === directions.LEFT,
        'kd-grafik-url__text--bottom': orientation === directions.BOTTOM,
      }"
  >
    {{ url || 'www.hach.de' }}
  </div>
</template>

<script>
import directions from '@/shared/directions';

export default {
  props: {
    orientation: {
      type: String,
      default: directions.BOTTOM,
    },
    url: {
      tyle: String,
      default: '', // it is possible that '' (empty) string is passed as prop, so default would have no effect
    },
  },
  computed: {
    directions() { return directions; },
    isVertical() {
      return this.orientation === directions.LEFT
        || this.orientation === directions.RIGHT;
    },
  },
};
</script>

<style lang="scss">
.kd-url-layer {
  width: 100%;
  height: 100%;
}

.kd-grafik-url__text {
  font-size: 5pt;
  white-space: nowrap;

  &--rotated {
    position: absolute;
    top: 50%;
    left: 50%;
    transform-origin: left top;
  }

  &--right {
    transform: rotate(-270deg) translateX(-50%) translateY(-50%);
  }

  &--left {
    transform: rotate(-90deg) translateX(-50%) translateY(-50%);
  }
  &--bottom {
    text-align: center;
  }
}
</style>
